// extracted by mini-css-extract-plugin
module.exports = {"nav_link_icon":"IconNavLink_nav_link_icon__2dtpj"};